import { Breadcrumb } from 'antd';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { ReactSVG } from 'react-svg';
import { HeaderWrapper, PageHeaderStyle } from './style';

function PageHeader(props) {
  const { title, subTitle, routes, buttons, ghost, bgColor, className, title2 } = props;
  const breadcrumb = routes ? (
    <Breadcrumb
      className="flex order-2 relative top-1.5"
      separator={<span className="inline-flex bg-light-extra relative -top-0.5 w-1 h-1 rounded-full" />}
    >
      {routes.map((route, index) =>
        index + 1 === routes.length ? (
          <Breadcrumb.Item key={index} className="text-breadcrumbs dark:text-white30 text-15">
            {route.breadcrumbName}
          </Breadcrumb.Item>
        ) : (
          <Breadcrumb.Item key={index} className="inline-flex items-start">
            <ReactSVG
              className="relative top-0.5 ltr:mr-2 rtl:ml-2 [&>div>svg]:text-[#8c90a4] dark:[&>div>svg]:text-white60 "
              src={require(`../../static/img/icon/home.svg`).default}
            />{' '}
            <Link
              to={route.path}
              className="text-light hover:text-primary dark:text-[#a4a5aa] dark:hover:text-white87 text-sm"
            >
              {route.breadcrumbName}
            </Link>
          </Breadcrumb.Item>
        ),
      )}
    </Breadcrumb>
  ) : (
    ''
  );
  return (
    <HeaderWrapper bgColor={bgColor}>
      <PageHeaderStyle className={`${className}`} breadcrumb={breadcrumb} extra={buttons} ghost={ghost}>
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
          <div className="flex items-center gap-3 flex-wrap">
            <h2 className="text-2xl font-semibold text-gray-900 dark:text-white">{title}</h2>
            <div className="">
              {title2 && <p className="text-base text-gray-500 dark:text-gray-400 mb-[-4px]">{title2}</p>}
              {subTitle && <p className="text-base text-gray-500 dark:text-gray-400 mt-[-4px]">{subTitle}</p>}
            </div>
          </div>
          {buttons && <div className="flex-shrink-0">{buttons}</div>}
        </div>
      </PageHeaderStyle>
    </HeaderWrapper>
  );
}

PageHeader.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  subTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  bgColor: PropTypes.string,
  className: PropTypes.string,
  routes: PropTypes.arrayOf(PropTypes.object),
  buttons: PropTypes.array,
  ghost: PropTypes.bool,
};

export { PageHeader };
